import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/work_orders',
  component: Management,
  redirect: '/work_orders/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/work_orders/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listWorkOrders
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/work_orders/ListTable'),
          meta: {
            auth: Auth.listWorkOrders,
            tabName: 'all'
          }
        },
        {
          path: 'open',
          component: () => import('@/views/work_orders/ListTable'),
          meta: {
            auth: Auth.listWorkOrders,
            tabName: 'open'
          }
        },
        {
          path: 'processing',
          component: () => import('@/views/work_orders/ListTable'),
          meta: {
            auth: Auth.listWorkOrders,
            tabName: 'processing'
          }
        },
        {
          path: 'resolved',
          component: () => import('@/views/work_orders/ListTable'),
          meta: {
            auth: Auth.listWorkOrders,
            tabName: 'resolved'
          }
        },
        {
          path: 'paid',
          component: () => import('@/views/work_orders/ListTable'),
          meta: {
            auth: Auth.listWorkOrders,
            tabName: 'paid'
          }
        },
        {
          path: 'closed',
          component: () => import('@/views/work_orders/ListTable'),
          meta: {
            auth: Auth.listWorkOrders,
            tabName: 'closed'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/work_orders/New'),
      meta: {
        auth: Auth.createWorkOrder
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/work_orders/Edit'),
      meta: {
        auth: Auth.updateWorkOrder
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/work_orders/DetailLayout'),
      meta: {
        auth: Auth.showWorkOrder
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/work_orders/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showWorkOrder
          }
        }
      ]
    }
  ]
}
